// @flow

import React, { Fragment } from 'react'
import styled, { css } from 'styled-components'
import Colors from 'components/styles/colors'
import { mediaMin } from 'frontend_core/dist/styles/media'
import { fontSize, spacing } from 'frontend_core/dist/styles/variables'
import { clearFix } from 'components/styles/helpers'
import LinkText from 'components/atoms/LinkText'
import Icon from 'components/atoms/Icon'

const HeadLine = styled.div`
  ${clearFix()};
`
const Title = styled.p`
  float: left;
  font-size: ${fontSize.small_3}px;
  font-weight: bold;
`
const LinkTextWrapper = styled.p`
  float: right;
`
const FeeBlock = styled.div`
  margin-top: ${spacing.medium}px;
  font-size: ${fontSize.small_3}px;
  line-height: 1.5;
  ${clearFix()};
`
const FeeTitle = styled.span`
  display: inline-block;
  float: left;
`
const FeeTitleTotal = FeeTitle.extend`
  font-weight: bold;
`
const FeeDetail = styled.span`
  display: inline-block;
  float: right;
  ${({ isDiscount }) =>
    isDiscount &&
    css`
      color: ${Colors.red};
    `};
`
const FeeTitleAdd = styled.div`
  width: 65%;
  float: left;
  font-weight: bold;
`
const FeeDetailAdd = styled.div`
  width: 35%;
  text-align: right;
  float: right;
  font-weight: bold;
`

type BillItem = {
  name: string,
  price: string,
  isDiscount?: boolean,
  number?: ?number,
}

function BillItemComponent(props: BillItem) {
  return (
    <FeeBlock>
      <FeeTitle>
        {props.name}
        {props.number && `×${props.number}個`}
      </FeeTitle>
      <FeeDetail isDiscount={props.isDiscount}>{props.price}</FeeDetail>
    </FeeBlock>
  )
}

export type PropTypes = {
  hrefReceipt?: ?string,
  hrefBill?: ?string,
  planBillItem: BillItem,
  extraGuestStayBillItem?: BillItem,
  optionCleaningBillItem?: BillItem,
  optionBillItemList?: Array<BillItem>,
  changePriceBillItem?: BillItem,
  lastMinuteDiscountBillItem?: BillItem,
  weeklyDiscountBillItem?: BillItem,
  monthlyDiscountBillItem?: BillItem,
  guestFeeBillItem?: BillItem,
  pointDiscountBillItem?: BillItem,
  guestPostpayFeeBillItem?: BillItem,
  salesTaxBillItem?: BillItem,
  couponDiscountBillItem?: BillItem,
  billTotal: string,
}

export default function BillStatementCurrent(props: PropTypes) {
  return (
    <Fragment>
      <HeadLine>
        <Title>{i18n.t('page.dashboard.reservation.chargeDetails')}</Title>
        {props.hrefReceipt && (
          <LinkTextWrapper>
            <LinkText href={props.hrefReceipt || ''} target="_blank">
              <Icon
                className="icon-spm-download"
                positionType="left"
                fontSizeSp={fontSize.small_3}
              />
              {i18n.t('page.dashboard.reservation.receipt')}
            </LinkText>
          </LinkTextWrapper>
        )}
      </HeadLine>
      <dd>
        <dl>
          <BillItemComponent {...props.planBillItem} />
          {props.extraGuestStayBillItem && (
            <BillItemComponent
              {...props.extraGuestStayBillItem}
              name={i18n.t('page.dashboard.reservation.extraGuestStay')}
            />
          )}
          {props.optionCleaningBillItem && (
            <BillItemComponent
              {...props.optionCleaningBillItem}
              name={i18n.t('page.shared.managementFee')}
            />
          )}
          {props.optionBillItemList &&
            props.optionBillItemList.map((option: BillItem, index: number) => (
              <BillItemComponent
                key={`change_reservation_option_${index}`}
                {...option}
              />
            ))}
          {props.changePriceBillItem && (
            <BillItemComponent {...props.changePriceBillItem} />
          )}
          {props.lastMinuteDiscountBillItem && (
            <BillItemComponent
              {...props.lastMinuteDiscountBillItem}
              name={i18n.t('page.dashboard.reservation.lastMinutesDiscount')}
              isDiscount
            />
          )}
          {props.weeklyDiscountBillItem && (
            <BillItemComponent
              {...props.weeklyDiscountBillItem}
              name={i18n.t('page.dashboard.reservation.weeklyDiscount')}
              isDiscount
            />
          )}
          {props.monthlyDiscountBillItem && (
            <BillItemComponent
              {...props.monthlyDiscountBillItem}
              name={i18n.t('page.dashboard.reservation.monthlyDiscount')}
              isDiscount
            />
          )}
          {props.guestFeeBillItem && (
            <BillItemComponent
              {...props.guestFeeBillItem}
              name={i18n.t('page.dashboard.reservation.guestFee')}
            />
          )}
          {props.pointDiscountBillItem && (
            <BillItemComponent
              {...props.pointDiscountBillItem}
              name={i18n.t('page.dashboard.reservation.pointDiscount')}
              isDiscount
            />
          )}
          {props.guestPostpayFeeBillItem && (
            <BillItemComponent
              {...props.guestPostpayFeeBillItem}
              name={i18n.t('page.dashboard.reservation.guestPostpayFee')}
            />
          )}
          {props.salesTaxBillItem && (
            <BillItemComponent
              {...props.salesTaxBillItem}
              name={i18n.t('page.dashboard.reservation.salesTax')}
            />
          )}
          {props.couponDiscountBillItem && (
            <BillItemComponent
              {...props.couponDiscountBillItem}
              name={i18n.t('page.dashboard.reservation.couponDiscount')}
              isDiscount
            />
          )}
          <FeeBlock>
            <FeeTitleAdd>
              {i18n.t('page.dashboard.reservation.total')}
            </FeeTitleAdd>
            <FeeDetailAdd>{props.billTotal}</FeeDetailAdd>
          </FeeBlock>
        </dl>
      </dd>
    </Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/components/molecules/BillStatementCurrent/index.jsx